import React from 'react';
import { Image, Svg } from '../../../snippets';
import { useOpenMediaModal } from './useOpenMediaModal';

export function ProductMediaThumbnails({ selectedMedia }) {
  const { handleModal } = useOpenMediaModal();

  return (
    <ul className="grid grid-cols-2 gap-8">
      {selectedMedia?.map(
        ({ mediaContentType, image, product, sources, preview }, index) => {
          const altText = image?.altText || '';
          let previewSrc = image?.src;
          if (mediaContentType === 'VIDEO') {
            previewSrc = preview?.image?.src;
          }
          const videoClasses = mediaContentType === 'VIDEO' ? 'col-span-2' : '';
          const firstClasses = index === 0 ? 'md:hidden' : '';
          return (
            <li key={index} className={`${videoClasses} ${firstClasses}`}>
              <button
                aria-label={`Open product image ${index + 1} in modal`}
                className={`relative flex h-full w-full items-center justify-center overflow-hidden bg-[#E6F0F8] transition
                ${
                  mediaContentType === 'VIDEO'
                    ? 'aspect-[893/595]'
                    : 'aspect-square'
                }
                `}
                onClick={() => {
                  if (mediaContentType !== 'VIDEO' && previewSrc) {
                    handleModal({ imageSrc: previewSrc, altText });
                  } else {
                    handleModal({ videoSources: sources });
                  }
                }}
                type="button"
              >
                {previewSrc && (
                  <Image
                    alt={product.title}
                    fill
                    className={` ${
                      mediaContentType === 'VIDEO'
                        ? ''
                        : '!object-contain !mix-blend-multiply'
                    }`}
                    sizes="(min-width: 1440px) 500px, (min-width: 768px) 50vw, 100vw"
                    priority={index < 2}
                    src={previewSrc}
                  />
                )}

                {mediaContentType === 'VIDEO' && (
                  <div className="absolute bottom-[30px] right-[30px] flex h-[47px] w-[47px] items-center justify-center rounded-full bg-gradient-to-t from-[#8DCEF9] to-[#C1EFFA]">
                    <div className="flex h-full w-full scale-95 items-center justify-center rounded-full bg-white">
                      <Svg
                        className="w-[14px] text-textLink"
                        src="/svgs/play.svg#play"
                        title="Play"
                        viewBox="0 0 24 24"
                      />
                    </div>
                  </div>
                )}
              </button>
            </li>
          );
        }
      )}
    </ul>
  );
}

ProductMediaThumbnails.displayName = 'ProductMediaThumbnails';
